// @ts-strict-ignore
import {
  Notification,
  dismissNotifications as apiDismissNotifications,
  fetchNotifications as apiFetchNotifications,
} from 'api/userNotifications';
import { sortNotifications } from 'utils/userNotifications';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '..';

// Types

export type UserNotifications = {
  notifications: Notification[];
  isFetching?: boolean;
  isLoaded: boolean;
};
export type State = UserNotifications;

type FetchNotificationsRequestAction = {
  type: 'NOTIFICATIONS_FETCH_REQUEST';
};
type FetchNotificationsSuccessAction = {
  type: 'NOTIFICATIONS_FETCH_SUCCESS';
  notifications: Notification[];
};
export type Action =
  | FetchNotificationsRequestAction
  | FetchNotificationsSuccessAction;

// Reducer

export function userNotificationsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    notifications: [],
    isLoaded: false,
  },
  action: Action
) {
  switch (action.type) {
    case 'NOTIFICATIONS_FETCH_REQUEST':
      return { ...state, isFetching: true };

    case 'NOTIFICATIONS_FETCH_SUCCESS':
      return {
        ...state,
        notifications: action.notifications,
        isFetching: false,
        isLoaded: true,
      };

    default:
      return state;
  }
}

// Actions

const fetchNotificationsRequest = (): FetchNotificationsRequestAction => ({
  type: 'NOTIFICATIONS_FETCH_REQUEST',
});

const fetchNotificationsSuccess = (
  notifications: Notification[]
): FetchNotificationsSuccessAction => ({
  type: 'NOTIFICATIONS_FETCH_SUCCESS',
  notifications,
});

export const fetchNotifications =
  () => (dispatch: Dispatch, getState: GetState) => {
    const notifications = getState().userNotifications;

    if (notifications && notifications.isFetching) {
      return Promise.resolve() as Promise<void>;
    }

    dispatch(fetchNotificationsRequest());
    return apiFetchNotifications().then((fetchedNotifications) => {
      const sortedNotifications = sortNotifications(fetchedNotifications);
      dispatch(fetchNotificationsSuccess(sortedNotifications));
    });
  };
export const dismissNotifications =
  (ids: Array<string>) => (dispatch: Dispatch) => {
    dispatch(fetchNotificationsRequest());
    return apiDismissNotifications(ids).then((fetchedNotifications) => {
      const sortedNotifications = sortNotifications(fetchedNotifications);
      dispatch(fetchNotificationsSuccess(sortedNotifications));
    });
  };
